<template>
  <div class="card floating">
    <div class="card-content">
      <p>{{ $t('prompts.createAccount') }}</p>
    </div>
    <div class="card-action">
      <button @click="cancel" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="crearCuenta"
        class="button button--flat button--red" id ="buttonDelete"
        :aria-label="$t('login.signup')"
        :title="$t('login.signup')">{{ $t('login.signup') }}</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import * as auth from '@/utils/auth';
import { files as ibbapi } from '@/api';

export default {
  name: 'create-account',
  data: function () {
    return {
      isLoading: false,
      emailUser: ''
    };
  },
  computed: {
    ...mapState([ 'createAccountCoupon' ])
  },
  async mounted () {
    try {
      let action = await ibbapi.getUserInfo();
      this.emailUser = action.userInfo.email;
    } catch (e) {
      this.$showError(e);
    }
  },
  methods: {
    ...mapMutations(['closeHovers', 'setCreateAccountCoupon']),
    async crearCuenta() {
      try {
        await auth.createAccountForCurrentUser(this.emailUser, this.createAccountCoupon.trim());
        this.$router.push({ path: '/promo' });
      } catch (e) {
        if (e == Module.ErrorType.E_INVOICING.value)
        {
          this.$router.push({ path: '/promo' });
          return;
        } else if (e == Module.ErrorType.E_FORBIDDEN.value) {
          this.$showError(this.$t('errors.errorCreateAccount'));
          this.$store.commit('closeHovers');
        }
      }
    },
    cancel () {
      this.$store.commit('closeHovers');
    }
  },
  beforeDestroy () {
    this.$store.commit('setCreateAccountCoupon', '');
    this.closeHovers();
  }
};
</script>